const rootStyle = getComputedStyle(document.documentElement)
const breakpoints = {
  xs: parseInt(rootStyle.getPropertyValue('--breakpoint-xs')) || 0,
  sm: parseInt(rootStyle.getPropertyValue('--breakpoint-sm')) || 576,
  md: parseInt(rootStyle.getPropertyValue('--breakpoint-md')) || 768,
  lg: parseInt(rootStyle.getPropertyValue('--breakpoint-lg')) || 992,
  xl: parseInt(rootStyle.getPropertyValue('--breakpoint-xl')) || 1200,
}

const initTabs = () => {
  const tabContainers = document.querySelectorAll('.hermetic-locations-tab--wrapper')

  tabContainers.forEach((tabContainer) => {
    const tabLinks = tabContainer.querySelectorAll('.nav-link')
    const tabPanes = tabContainer.querySelectorAll('.tab-pane')
    const headingLabel = tabContainer.querySelector('.hermetic-locations-tab--heading-label')

    if (!tabLinks.length || !tabPanes.length) return

    const getLinkLabel = (link) => {
      const headline = link.querySelector('h3')
      return (headline ? headline.textContent : link.textContent).trim()
    }

    const updateHeading = (link) => {
      if (!headingLabel) return
      const label = getLinkLabel(link)
      if (label) headingLabel.textContent = label
    }

    const activate = (index) => {
      tabLinks.forEach((link, i) => {
        const isActive = i === index
        link.classList.toggle('active', isActive)
        link.setAttribute('aria-selected', isActive ? 'true' : 'false')
      })

      tabPanes.forEach((pane, i) => {
        const isActive = i === index
        pane.classList.toggle('show', isActive)
        pane.classList.toggle('active', isActive)
      })

      updateHeading(tabLinks[index])
    }

    const scrollToContent = () => {
      if (window.innerWidth >= breakpoints.md) return
      const target = tabContainer.querySelector('.neos-nodetypes-headline') || tabContainer.querySelector('.tab-content')
      if (!target) return
      const offset = target.getBoundingClientRect().top + window.pageYOffset - 16
      window.scrollTo({ top: offset, behavior: 'smooth' })
    }

    tabLinks.forEach((link, index) => {
      link.addEventListener('click', (event) => {
        event.preventDefault()
        activate(index)
        scrollToContent()
      })
    })

    let initialIndex = 0
    tabLinks.forEach((link, index) => {
      if (link.classList.contains('active')) {
        initialIndex = index
      }
    })
    activate(initialIndex)
  })
}

const processHash = () => {
  const hash = window.location.hash
  if (!hash || hash.indexOf('#content-') !== 0) return

  const target = document.querySelector(hash)
  if (!target || !target.classList.contains('tab-pane')) return

  const wrapper = target.closest('.hermetic-locations-tab--wrapper')
  if (!wrapper) return

  const link = wrapper.querySelector('.nav-link[href="' + hash + '"]')
  if (!link) return

  link.click()

  const offset = wrapper.getBoundingClientRect().top + window.pageYOffset - 200
  window.scrollTo({ top: offset, behavior: 'smooth' })
}

const start = () => {
  initTabs()
  processHash()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start)
} else {
  start()
}

window.addEventListener('hashchange', processHash)
